export default __webpack_public_path__ + "img/NF.2979c7b4064d706e29deeec0da6dcfe9.jpg";